interface UpdateBannerProps {
  needRefresh: boolean;
}

export default function UpdateBanner({ needRefresh }: UpdateBannerProps) {
  if (!needRefresh) return null;

  return (
    <div className="update-banner">
      <span>A new version is available — updating...</span>
      <button
        onClick={() => window.location.reload()}
        className="ml-2 underline font-semibold"
      >
        Reload now
      </button>
    </div>
  );
}
